import { getOrders } from '../services/accountService'

function fetchOrders(accountNumber, type) {
  return getOrders(accountNumber, type)
}

export default fetchOrders



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchOrders.js